import { render, staticRenderFns } from "./preloads.vue?vue&type=template&id=48c9c0a2"
import script from "./preloads.vue?vue&type=script&lang=js"
export * from "./preloads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports